import React, { useEffect, useState } from 'react';
import Hero from '../components/Hero';
import LiveTicker from '../components/LiveTicker';
import CategoryPills from '../components/CategoryPills';
import OfferCard from '../components/OfferCard';
//import StickyCTA from '../components/StickyCTA';
import Footer from '../components/Footer';
import { featuredOffers, gameOffers, surveyOffers, appOffers, vpnOffers } from '../data/offers';
import { Zap, ChevronRight, Gamepad2, Gift, Smartphone, Shield, Loader2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import PremiumCards from '../components/PremiumCards';

const Home = () => {
  const [loading, setLoading] = useState(true);
  const [dataLoading, setDataLoading] = useState(true);

  useEffect(() => {
    // Top-level page loader
    const timer = setTimeout(() => {
      setLoading(false);
    }, 800);

    // Data placeholder loader
    const dataTimer = setTimeout(() => {
      setDataLoading(false);
    }, 2000);

    try {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (err) {
      // ignore
    }

    return () => {
      clearTimeout(timer);
      clearTimeout(dataTimer);
    };
  }, []);

  const SkeletonCard = () => (
    <div className="bg-[#1a1a1a] rounded-xl border border-gray-800 p-4 animate-pulse">
      <div className="w-full h-40 bg-gray-800 rounded-lg mb-4"></div>
      <div className="h-6 bg-gray-700/50 rounded w-3/4 mb-2"></div>
      <div className="h-4 bg-gray-700/50 rounded w-1/2 mb-4"></div>
      <div className="h-10 bg-gray-700/50 rounded w-full"></div>
    </div>
  );

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-[#0f0f0f] text-white">
        <Loader2 className="w-12 h-12 text-indigo-500 animate-spin mb-4" />
        <h2 className="text-xl font-bold">Loading Amazing Offers...</h2>
      </div>
    );
  }

  return (
    <div className="animate-in fade-in slide-in-from-bottom-2 duration-500  max-w-full mx-auto">
      <Hero />
      <LiveTicker />
      <CategoryPills />

      <section id="featured-offers" className="px-4 py-4">
        <div className="flex items-center gap-2 mb-4">
          <Zap className="w-5 h-5 text-yellow-500 fill-yellow-500" />
          <h2 className="text-lg font-bold">🔥 Hottest Offers Today</h2>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {dataLoading 
            ? Array(4).fill(0).map((_, i) => <SkeletonCard key={i} />)
            : featuredOffers.map((offer) => (
                <OfferCard key={offer.id} offer={offer} />
              ))
          }
        </div>
      </section>

      <section className="px-4 py-4">
        <div className="px-4 flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <Gamepad2 className="w-5 h-5 text-yellow-400" />
            <h2 className="text-lg font-bold">Popular Mobile Games</h2>
          </div>
          <Link to="/category/games" className="text-indigo-400 text-sm flex items-center gap-1">
            See All <ChevronRight className="w-4 h-4" />
          </Link>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {dataLoading 
            ? Array(4).fill(0).map((_, i) => <SkeletonCard key={i} />)
            : gameOffers.slice(0, 4).map((game) => (
                <OfferCard key={game.id} offer={game} />
              ))
          }
        </div>
      </section>

      <section className="px-4 py-4">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <Gift className="w-5 h-5 text-red-400" />
            <h2 className="text-lg font-bold">Surveys & Rewards</h2>
          </div>
          <Link to="/category/rewards" className="text-indigo-400 text-sm flex items-center gap-1">
            See All <ChevronRight className="w-4 h-4" />
          </Link>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {dataLoading 
            ? Array(4).fill(0).map((_, i) => <SkeletonCard key={i} />)
            : surveyOffers.slice(0, 4).map((survey) => (
                <OfferCard key={survey.id} offer={survey} />
              ))
          }
        </div>
      </section>

      <section className="px-4 py-4">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <Smartphone className="w-5 h-5 text-blue-400" />
            <h2 className="text-lg font-bold">Money Making Apps</h2>
          </div>
          <Link to="/category/apps" className="text-indigo-400 text-sm flex items-center gap-1">
            See All <ChevronRight className="w-4 h-4" />
          </Link>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {dataLoading 
            ? Array(4).fill(0).map((_, i) => <SkeletonCard key={i} />)
            : appOffers.slice(0, 4).map((app) => (
                <OfferCard key={app.id} offer={app} />
              ))
          }
        </div>
      </section>

      <section className="px-4 py-4">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <Shield className="w-5 h-5 text-cyan-400" />
            <h2 className="text-lg font-bold">VPN & Security</h2>
          </div>
          <Link to="/category/vpns" className="text-indigo-400 text-sm flex items-center gap-1">
            See All <ChevronRight className="w-4 h-4" />
          </Link>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {dataLoading 
            ? Array(4).fill(0).map((_, i) => <SkeletonCard key={i} />)
            : vpnOffers.map((vpn) => (
                <OfferCard key={vpn.id} offer={vpn} />
              ))
          }
        </div>
      </section>

      

      <section className="px-4 mt-12">
        <div className="flex items-center gap-2 mb-4">
          <h2 className="text-lg font-bold">🎁 Featured Gift Cards</h2>
        </div>
        
        <PremiumCards/>
      </section>

      {/* <StickyCTA /> */}
      <Footer />
    </div>
  );
};

export default Home;
